import { render, staticRenderFns } from "./RPMgmActivityEffect.vue?vue&type=template&id=2eba09a6"
import script from "./RPMgmActivityEffect.vue?vue&type=script&lang=js"
export * from "./RPMgmActivityEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports